/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import RefundTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ModalCommon from "components/Modal/Modal";
import ModalContent from "./components/modalContent";
import Actions from "./components/actions";
import Tabs from "./components/tabs";
import SelectField from "components/SelectField";
import SoftTypography from "components/SoftTypography";
import RefundRequestTable from "./components/refund-request-table";
import Footer from "./components/footer";
import { useEffect } from "react";
const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];
const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};
export default function DNHT() {
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [isPeriod, setIsPeriod] = React.useState("firstTime");
  const [list, setList] = React.useState([{ name: "01-1/BK-XSBHĐC", checked: false }]);

  const { formId, formField } = form;
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
            isPeriod={isPeriod}
            setIsPeriod={setIsPeriod}
          />
        }
      >
        <Box display="flex" flexDirection="column" pb={10} gap={3}>
          <Box textAlign="center">
            <Typography variant="h4" textTransform="uppercase">
              Giấy đề nghị hoàn trả khoản thu ngân sách nhà nước
            </Typography>
            <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
              (Áp dụng đối với doanh nghiệp xổ số, bảo hiểm, bán hàng đa cấp trả tiền hoa hồng cho
              cá nhân trực tiếp ký hợp đồng làm đại lý bán đúng giá; doanh nghiệp bảo hiểm trả phí
              tích lũy bảo hiểm nhân thọ, bảo hiểm không bắt buộc khác)
            </Typography>
          </Box>
          <Formik
            initialValues={initialValues}
            validationSchema={validation}
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, isSubmitting, setFieldValue }) => (
              <Form id={formId} autoComplete="off">
                <Fields
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                    isPeriod,
                    setIsPeriod,
                    setFieldValue,
                  }}
                />
                <RefundTable
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                  setFieldValue={setFieldValue}
                />
                <RefundRequestTable
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                  setFieldValue={setFieldValue}
                />
                <MoreFields
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                />

                <Footer
                  formData={{
                    values,
                    touched,
                    formField,
                    errors,
                  }}
                />
                <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                  <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark">
                    {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                  </SoftButton>
                </SoftBox>
              </Form>
            )}
          </Formik>
        </Box>
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched, isPeriod, setIsPeriod, setFieldValue } = formData;
  const {
    accountOwner,
    bankAccountNumber,
    bankName,
    certificateNumber,
    chiefAccountant,
    documentNumber,
    signer,
    taxAgentCode,
    taxAgentName,
    taxCode,
    taxPayers,
    timeSign,
    whyRefund,
    sendTo,
    taxRefundAfter,
    taxRefundBefore,
    dateRange,
    identifier,
    issuedBy,
    taxpayerCountry,
  } = formField;
  useEffect(() => {
    if (isPeriod === "taxRefundAfter") {
      setFieldValue("taxRefundAfter", true);
      setFieldValue("taxRefundBefore", false);
    } else {
      setFieldValue("taxRefundBefore", true);
      setFieldValue("taxRefundAfter", false);
    }
  }, [isPeriod, values]);
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={documentNumber.name}
            label={documentNumber.label}
            value={values.documentNumber}
            error={errors.documentNumber && touched.documentNumber}
            success={values.documentNumber?.toString().length > 0 && !errors.documentNumber}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField
            name={taxRefundAfter.name}
            label={taxRefundAfter.label}
            value={values.taxRefundAfter}
            onToggle={(e) => e && setIsPeriod("taxRefundAfter")}
            defaultValue={isPeriod === "taxRefundAfter"}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField
            name={taxRefundBefore.name}
            label={taxRefundBefore.label}
            value={values.taxRefundBefore}
            onToggle={(e) => e && setIsPeriod("taxRefundBefore")}
            defaultValue={isPeriod === "taxRefundBefore"}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={sendTo.name}
            label={sendTo.label}
            value={values.sendTo}
            error={errors.sendTo && touched.sendTo}
            success={values.sendTo?.toString().length > 0 && !errors.sendTo}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SoftBox display="flex" flexDirection="column" my={1}>
            <SoftTypography
              component="div"
              fontSize={13}
              variant="caption"
              fontWeight="bold"
              mb={0.5}
            >
              I - thông tin về tổ chức đề nghị hoàn trả
            </SoftTypography>
          </SoftBox>
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxPayers.name}
            label={taxPayers.label}
            value={values.taxPayers}
            error={errors.taxPayers && touched.taxPayers}
            success={values.taxPayers?.toString().length > 0 && !errors.taxPayers}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxCode.name}
            label={taxCode.label}
            value={values.taxCode}
            error={errors.taxCode && touched.taxCode}
            success={values.taxCode?.toString().length > 0 && !errors.taxCode}
          />
        </Grid>
        {/* // */}

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={identifier.name}
            label={identifier.label}
            value={values.identifier}
            error={errors.identifier && touched.identifier}
            success={values.identifier?.toString().length > 0 && !errors.identifier}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={dateRange.name}
            label={dateRange.label}
            value={values.dateRange}
            error={errors.dateRange && touched.dateRange}
            success={values.dateRange?.toString().length > 0 && !errors.dateRange}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={issuedBy.name}
            label={issuedBy.label}
            value={values.issuedBy}
            error={errors.issuedBy && touched.issuedBy}
            success={values.issuedBy?.toString().length > 0 && !errors.issuedBy}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerCountry.name}
            label={taxpayerCountry.label}
            value={values.taxpayerCountry}
            error={errors.taxpayerCountry && touched.taxpayerCountry}
            success={values.taxpayerCountry?.toString().length > 0 && !errors.taxpayerCountry}
          />
        </Grid>

        {/* // */}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentName.name}
            label={taxAgentName.label}
            value={values.taxAgentName}
            error={errors.taxAgentName && touched.taxAgentName}
            success={values.taxAgentName?.toString().length > 0 && !errors.taxAgentName}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentCode.name}
            label={taxAgentCode.label}
            value={values.taxAgentCode}
            error={errors.taxAgentCode && touched.taxAgentCode}
            success={values.taxAgentCode?.toString().length > 0 && !errors.taxAgentCode}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
function MoreFields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { accountOwner, bankAccountNumber, bankName, attachDocument } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 30 }}>
          <SoftBox display="flex" flexDirection="column" my={1}>
            <SoftTypography component="label" variant="caption" fontWeight="normal" mb={0.5}>
              b. Hoàn trả trực tiếp
            </SoftTypography>
          </SoftBox>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={accountOwner.name}
            label={accountOwner.label}
            value={values.accountOwner}
            error={errors.accountOwner && touched.accountOwner}
            success={values.accountOwner?.toString().length > 0 && !errors.accountOwner}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={bankAccountNumber.name}
            label={bankAccountNumber.label}
            value={values.bankAccountNumber}
            error={errors.bankAccountNumber && touched.bankAccountNumber}
            success={values.bankAccountNumber?.toString().length > 0 && !errors.bankAccountNumber}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={bankName.name}
            label={bankName.label}
            value={values.bankName}
            error={errors.bankName && touched.bankName}
            success={values.bankName?.toString().length > 0 && !errors.bankName}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={attachDocument.name}
            label={attachDocument.label}
            value={values.attachDocument}
            error={errors.attachDocument && touched.attachDocument}
            success={values.attachDocument?.toString().length > 0 && !errors.attachDocument}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
